import AssetstoreModel from 'girder/models/AssetstoreModel';
import Collection from 'girder/collections/Collection';

var AssetstoreCollection = Collection.extend({
    resourceName: 'assetstore',
    model: AssetstoreModel
});

export default AssetstoreCollection;



// WEBPACK FOOTER //
// ./clients/web/src/collections/AssetstoreCollection.js